import type {
  AbstractSideNavigationItem,
  SideNavigationGroupItem,
} from '#variant/components/navigation/types';

export const useLabelTranslation = () => {
  const { t } = useI18n();
  const getTranslation = (
    item: AbstractSideNavigationItem | SideNavigationGroupItem,
  ) => {
    if (item.translate) return t(item.label);

    return item.label;
  };

  return getTranslation;
};
